@if (confirmation(); as dialog) {
  <div class="confirmation-dialog-mask" role="presentation" (click)="onMaskClick($event, dialog)">
    <section
      class="confirmation-dialog"
      [class]="'confirmation-dialog ' + styleClass()"
      role="alertdialog"
      aria-modal="true"
      [attr.aria-labelledby]="'confirmation-dialog-title-' + (key() || 'default')"
    >
      @if (dialog.closable !== false) {
        <button type="button" class="confirmation-dialog__close" aria-label="Close" (click)="cancel(dialog)">
          <i class="app-icon app-icon-times" aria-hidden="true"></i>
        </button>
      }

      <div class="confirmation-dialog__glyph" [class.info]="dialog.severity === 'info'" aria-hidden="true">
        @switch (dialog.icon) {
          @case ('mail') {
            <i class="app-icon app-icon-envelope" aria-hidden="true"></i>
          }
          @case ('printer') {
            <i class="app-icon app-icon-print" aria-hidden="true"></i>
          }
          @case ('trash') {
            <i class="app-icon app-icon-trash" aria-hidden="true"></i>
          }
          @default {
            <i class="app-icon app-icon-exclamation-triangle" aria-hidden="true"></i>
          }
        }
      </div>

      <h2 [id]="'confirmation-dialog-title-' + (key() || 'default')" class="confirmation-dialog__title">
        {{ dialog.header || 'Confirm' }}
      </h2>

      <div class="confirmation-dialog__body">
        <p>
          @if (dialog.messageParts?.length) {
            @for (part of dialog.messageParts; track $index) {
              @if (part.bold) {
                <strong>{{ part.text }}</strong>
              } @else {
                {{ part.text }}
              }
            }
          } @else {
            {{ dialog.message }}
          }
        </p>
      </div>

      <footer>
        @if (dialog.rejectLabel || dialog.rejectButtonProps?.label) {
          <button
            type="button"
            class="confirmation-dialog__button confirmation-dialog__button--secondary"
            [class]="
              'confirmation-dialog__button confirmation-dialog__button--secondary ' +
              (dialog.rejectButtonStyleClass || '')
            "
            (click)="reject(dialog)"
          >
            {{ dialog.rejectLabel || dialog.rejectButtonProps?.label }}
          </button>
        }
        <button
          type="button"
          class="confirmation-dialog__button confirmation-dialog__button--primary"
          [class]="
            'confirmation-dialog__button confirmation-dialog__button--primary ' + (dialog.acceptButtonStyleClass || '')
          "
          (click)="accept(dialog)"
        >
          {{ dialog.acceptLabel || 'Yes' }}
        </button>
      </footer>
    </section>
  </div>
}
